import { styled } from '@mui/material'
import Tab from '@mui/material/Tab'

export const StyledTab = styled(Tab)(({ theme }) => ({
  ...theme.typography.h6,
  flex: '0 0 50%',
  color: '#000',
  maxWidth: '100%',
  textTransform: 'none',
  minHeight: theme.spacing(4),
  padding: theme.spacing(0.5),
  '&.Mui-selected': {
    backgroundColor: 'white',
  },
}))
